import { createFileRoute } from '@tanstack/react-router';
import { EditCoursePage } from '@/pages/courses/EditCoursePage';

export const Route = createFileRoute('/_authenticated/_app/courses/$courseId_/edit')({
	component: EditCoursePage,
});
